import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutContainer } from '@cfp/shared/ui/layout-container';
import { NavService } from '@cfp/shared/ui/nav';
import { BuildingReportContent } from '../building-report/building-report-content';

@Component({
  selector: 'cfp-public-building-report',
  templateUrl: './public-building-report.html',
  styleUrls: ['./public-building-report.scss'],
  imports: [LayoutContainer, BuildingReportContent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicBuildingReport implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly navService = inject(NavService);

  protected readonly publicSharedId: string | undefined = this.route.snapshot.params.publicSharedId;
  protected readonly tabbar = signal<any[] | undefined>(undefined);

  public ngOnInit(): void {
    this.getTabbar();
  }

  private getTabbar(): void {
    const publicSharedId = this.publicSharedId;
    if (!publicSharedId) {
      return;
    }

    this.navService.getPublicTabbar(publicSharedId).subscribe((tabbar: any[]) => {
      this.tabbar.set(tabbar);

      if (!tabbar[0].license && tabbar[1].license) {
        // When report is not available, but roadmap is, navigate to the roadmap page
        this.router.navigateByUrl(`/public/buildings/${publicSharedId}/roadmap`);
      }
    });
  }
}
